import React from 'react'

export default function Callbten() {
  const num = "8679435072";
  const phone = "8679435072";
  const message = encodeURIComponent("Hi Looking For Service Soni Roy");
  return (
    <>
      <section className="rd-call-btns">
            <a href={`tel:${num}`}>Call Now</a>
            <a href={`https://wa.me/${phone}?text=${message}`}>Whatsapp</a>
      </section>
    </>
  )
}
